import { useState } from "react";
import { AiOutlineMenu } from "react-icons/ai";
import NavSidebarMobile from "../NavSidebarMobile/NavSidebarMobile";
import NavTopbarMobile from "../NavTopbarMobile/NavTopbarMobile";
import * as styles from "./NavbarMobile.module.css";

export default function NavbarMobile() {
  const [closeOrMenuIcon, setCloseOrMenuIcon] = useState(<AiOutlineMenu />);
  return (
    <nav className={styles.nav}>
      <div>
        <NavTopbarMobile
          iconToDisplay={closeOrMenuIcon}
          setIcon={(icon) => setCloseOrMenuIcon(icon)}
        />
        <NavSidebarMobile
          iconToDisplay={closeOrMenuIcon}
          setIcon={(icon) => setCloseOrMenuIcon(icon)}
        />
      </div>
    </nav>
  );
}
